<template>
  <section :class="modifier">
    <div container>
      <div grid="row wrap">
        <slot></slot>
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    props: ['modifier']
  }
</script>
